export const ViewTestState = {
	url: '/test',
	template: '<test-page></test-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "testPageCmpMod" */
			'@Containers/test-page/test-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
